module.exports = __webpack_public_path__ + "img/logotipo-dark.ee020fad.png";